export default __webpack_public_path__ + "static/media/linkedin.65c1ca02.svg";